import React, { useState, useEffect } from 'react';
import Nav from '../Nav';
import Footer from '../Footer';
import Content from '../Content';
import { Outlet } from 'react-router-dom';
import '../../assets/scss/bootstrapExtended.scss';
import './layout.scss';
import '../../styles/globalStyle.scss';
import { GlobalProvider } from '../../globalContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Layout = () => {
  const [conditionalRendering, setConditionalRendering] = useState(false);

  const conditionalRenderingData = () => {
    const url = window.location.href;
    const endString = url.substr(url.lastIndexOf('/') + 1);
    endString === 'standardPrinting'
      ? setConditionalRendering(true)
      : setConditionalRendering(false);
  };

  useEffect(() => {
    conditionalRenderingData();
  }, [window.location.href]);

  return (
    <React.Fragment>
      <GlobalProvider>
        {!conditionalRendering ? (
          <>
            <Nav />
            <Content>
              <div className="content-wrapper">
                <Outlet />
              </div>
              <Footer />
            </Content>
          </>
        ) : (
          <Outlet />
        )}
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </GlobalProvider>
    </React.Fragment>
  );
};

export default Layout;
